// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"7f631854","132":"5b81785e","282":"31eb25b8","338":"6c3b9875","392":"5f6414f8","409":"21cf6a79","778":"fcd293ac","916":"05d2b157"}[chunkId] + ".chunk.js";
};